import { render, staticRenderFns } from "./printTerminalShowPost.vue?vue&type=template&id=32bb150f&scoped=true&"
import script from "./printTerminalShowPost.vue?vue&type=script&lang=js&"
export * from "./printTerminalShowPost.vue?vue&type=script&lang=js&"
import style0 from "./printTerminalShowPost.vue?vue&type=style&index=0&id=32bb150f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bb150f",
  null
  
)

export default component.exports